import React, { useEffect, useRef, useState } from 'react';
import { Home } from 'lucide-react';
import { GLYPHS } from './glyphs';

// ON A PHONE the rail has no room, so Nucleus carries its own way around: a
// bar along the bottom with every section (Home first), and, on a section's
// page, its sibling pages as a strip under the header. Above 760px neither
// draws; the rail and the section column do the work.

const PHONE = '(max-width: 760px)';
export function useIsPhone() {
    const read = () => typeof window !== 'undefined' && !!window.matchMedia?.(PHONE).matches;
    const [phone, setPhone] = useState(read);
    useEffect(() => {
        const mq = window.matchMedia?.(PHONE);
        if (!mq) return undefined;
        const on = () => setPhone(mq.matches);
        mq.addEventListener?.('change', on);
        return () => mq.removeEventListener?.('change', on);
    }, []);
    return phone;
}

/** The bottom bar: Home, then every section, each its glyph in its layer's hue. */
export function PhoneBar({ doors, active, onHome }) {
    return (
        <nav className="nx-phonebar" aria-label="Sections">
            <button type="button" className={`nx-phonebar__door${!active ? ' is-on' : ''}`} onClick={onHome} aria-label="Home" aria-current={!active ? 'page' : undefined}>
                <Home size={18} strokeWidth={1.5} aria-hidden="true" />
            </button>
            {doors.map((d) => {
                const Glyph = GLYPHS[d.glyph];
                const on = active === d.id;
                return (
                    <button key={d.id} type="button" data-zone={d.zone} className={`nx-phonebar__door${on ? ' is-on' : ''}`}
                        onClick={d.go} aria-label={d.label} title={d.label} aria-current={on ? 'page' : undefined}>
                        {Glyph && <Glyph size={18} strokeWidth={1.5} aria-hidden="true" />}
                    </button>
                );
            })}
        </nav>
    );
}

/** A section's pages, side by side under the header, the one you are on lit. */
export function PageStrip({ pages, active, onSelect }) {
    const strip = useRef(null);
    // the page you are on is always in view, however far along the strip it sits
    useEffect(() => {
        const on = strip.current?.querySelector('.is-on');
        if (on && strip.current) strip.current.scrollLeft = Math.max(0, on.offsetLeft - 16);
    }, [active]);
    if (!pages || pages.length < 2) return null;
    return (
        <nav className="nx-pagestrip" aria-label="Pages" ref={strip}>
            {pages.map((p) => (
                <button key={p.id} type="button" className={`nx-pagestrip__page${p.id === active ? ' is-on' : ''}`}
                    aria-current={p.id === active ? 'page' : undefined} onClick={() => onSelect(p.id)}>
                    {p.label}
                </button>
            ))}
        </nav>
    );
}
